import { CoreIcon } from '../core-icon';
import dateSVG from '../../../src/images/icons/date.svg';

export const DateIcon = props => {
  return <CoreIcon src={dateSVG} {...props} />;
};
